/** Round down to a clean marketing figure (nearest 1k below 50k, else nearest 10k). */
export function roundForMarketing(count: number): number {
  if (count < 50_000) {
    return Math.floor(count / 1_000) * 1_000;
  }
  return Math.floor(count / 10_000) * 10_000;
}

/** Round lesson counts for marketing (nearest 100 below 1k, else same as games). */
export function roundLessonCountForMarketing(count: number): number {
  if (count < 1_000) {
    return Math.floor(count / 100) * 100;
  }
  return roundForMarketing(count);
}

export function formatEliteGameCount(count: number): string {
  return roundForMarketing(count).toLocaleString('en-US');
}

export function formatLessonCount(count: number): string {
  return roundLessonCountForMarketing(count).toLocaleString('en-US');
}
